import { createRouter, createWebHistory } from "vue-router";

import HomePage from "@/pages/HomePage.vue";
import PostPage from "@/pages/PostPage.vue";
import PostsPerCategoryPage from "@/pages/PostsPerCategoryPage.vue";
import SearchPage from "@/pages/SearchPage.vue";
import ContactPage from "@/pages/ContactPage.vue";
import SubscriptionPage from "@/pages/SubscriptionPage.vue";
import SubscribePage from "@/pages/SubscribePage.vue";
import RequestSubscriptionMagicLinkPage from "@/pages/RequestSubscriptionMagicLinkPage.vue";
import PageNotFound from "@/pages/PageNotFound.vue";
import MobileSubscribePage from "@/pages/mobile/MobileSubscribePage.vue";
import MobileRequestSubscriptionMagicLinkPage from "@/pages/mobile/MobileRequestSubscriptionMagicLinkPage.vue";
import VerifySubscriptionEmailPage from "@/pages/VerifySubscriptionEmailPage.vue";
import StartupsPage from "@/pages/StartupsPage.vue";
import TechEventsPage from "@/pages/TechEventsPage.vue";

const routes = [
  {
    name: "HomePage",
    path: "/",
    component: HomePage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "HomePageEn",
    path: "/en",
    component: HomePage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "HomePageFr",
    path: "/fr",
    component: HomePage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "PostPage",
    path: "/post/:slug/:id",
    component: PostPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "PostPageEn",
    path: "/en/post/:slug/:id",
    component: PostPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "PostPageFr",
    path: "/fr/post/:slug/:id",
    component: PostPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "SearchPage",
    path: "/search",
    component: SearchPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "SearchPageEn",
    path: "/en/search",
    component: SearchPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "SearchPageFr",
    path: "/fr/search",
    component: SearchPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "PostsPerCategoryPage",
    path: "/category/:slug",
    component: PostsPerCategoryPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "PostsPerCategoryPageEn",
    path: "/en/category/:slug",
    component: PostsPerCategoryPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "PostsPerCategoryPageFr",
    path: "/fr/category/:slug",
    component: PostsPerCategoryPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "StartupsPage",
    path: "/startups",
    component: StartupsPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "StartupsPageEn",
    path: "/en/startups",
    component: StartupsPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "StartupsPageFr",
    path: "/fr/startups",
    component: StartupsPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "TechEventsPage", 
    path: "/tech-events",
    component: TechEventsPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "TechEventsPageEn", 
    path: "/en/tech-events",
    component: TechEventsPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "TechEventsPageFr", 
    path: "/fr/tech-events",
    component: TechEventsPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  //contact
  {
    name: "ContactPage",
    path: "/contact",
    component: ContactPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "ContactPageEn",
    path: "/en/contact",
    component: ContactPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "ContactPageFr",
    path: "/fr/contact",
    component: ContactPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  // verify email
  {
    name: "VerifySubscriptionEmailPage",
    path: "/subscription/verify/:verification_token",
    component: VerifySubscriptionEmailPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "VerifySubscriptionEmailPageEn",
    path: "/en/subscription/verify/:verification_token",
    component: VerifySubscriptionEmailPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "VerifySubscriptionEmailPageFr",
    path: "/fr/subscription/verify/:verification_token",
    component: VerifySubscriptionEmailPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  //subscription
  {
    name: "SubscribePage",
    path: "/subscription/subscribe",
    component: SubscribePage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "SubscribePageEn",
    path: "/en/subscription/subscribe",
    component: SubscribePage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "SubscribePageFr",
    path: "/fr/subscription/subscribe",
    component: SubscribePage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "RequestSubscriptionMagicLinkPage",
    path: "/subscription/request-magic-link",
    component: RequestSubscriptionMagicLinkPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "RequestSubscriptionMagicLinkPageEn",
    path: "/en/subscription/request-magic-link",
    component: RequestSubscriptionMagicLinkPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "RequestSubscriptionMagicLinkPageFr",
    path: "/fr/subscription/request-magic-link",
    component: RequestSubscriptionMagicLinkPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "SubscriptionPage",
    path: "/subscription/:magic_token",
    component: SubscriptionPage,
    meta: { layout: "DefaultLayout" },
  },
  {
    name: "SubscriptionPageEn",
    path: "/en/subscription/:magic_token",
    component: SubscriptionPage,
    meta: { layout: "DefaultLayout", language: "en" },
  },
  {
    name: "SubscriptionPageFr",
    path: "/fr/subscription/:magic_token",
    component: SubscriptionPage,
    meta: { layout: "DefaultLayout", language: "fr" },
  },
  {
    name: "MobileSubscribePage",
    path: "/mobile/subscription/subscribe",
    component: MobileSubscribePage,
    meta: { layout: "MobileLayout" },
  },
  {
    name: "MobileSubscribePageEn",
    path: "/en/mobile/subscription/subscribe",
    component: MobileSubscribePage,
    meta: { layout: "MobileLayout", language: "en" },
  },
  {
    name: "MobileSubscribePageFr",
    path: "/fr/mobile/subscription/subscribe",
    component: MobileSubscribePage,
    meta: { layout: "MobileLayout", language: "fr" },
  },
  {
    name: "MobileRequestSubscriptionMagicLinkPage",
    path: "/mobile/subscription/request-magic-link",
    component: MobileRequestSubscriptionMagicLinkPage,
    meta: { layout: "MobileLayout" },
  },
  {
    name: "MobileRequestSubscriptionMagicLinkPageEn",
    path: "/en/mobile/subscription/request-magic-link",
    component: MobileRequestSubscriptionMagicLinkPage,
    meta: { layout: "MobileLayout", language: "en" },
  },
  {
    name: "MobileRequestSubscriptionMagicLinkPageFr",
    path: "/fr/mobile/subscription/request-magic-link",
    component: MobileRequestSubscriptionMagicLinkPage,
    meta: { layout: "MobileLayout", language: "fr" },
  },
  {
    name: "PageNotFound",
    path: "/:pathMatch(.*)*",
    component: PageNotFound,
    meta: { layout: "DefaultLayout" },
  },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

// Navigation guard to handle language detection from URL
router.beforeEach((to, from, next) => {
  // Extract language from URL path
  const pathLang = to.path.split('/')[1];
  
  if (['en', 'fr'].includes(pathLang)) {
    // Set language in store based on URL path
    const store = router.app.config.globalProperties.$store;
    if (store) {
      store.dispatch('locale/setLocale', pathLang);
    }
  }
  
  next();
});

export default router;
